import { useEffect } from 'react';
import { useRootDispatch, useRootSelector } from '../../../../store/hooks';
import { selectSiteHeader } from '../../../../store/features/siteHeader';
import { selectSiteContent } from '../../../../store/features/siteContent';
import {
  fetchFestivalProEventSchedule,
  selectFestivalProSchedule,
  selectFestivalProScheduleStatus,
} from '../../../../store/features/festivalProSchedule';
import s from './FestivalProSchedule.module.scss';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import Schedule from '../FestivalProGuestProfileView/GuestProfile/Schedule';
import Spinner from '../FestivalProGuestsView/Spinner';
import ExternalError from '../FestivalProGuestsView/ExternalError';
import ClosedSchedule from './ClosedSchedule';

export default function FestivalProScheduleView() {
  const dispatch = useRootDispatch();
  const {
    data: { festivalProEventId: eventId },
  } = useRootSelector(selectSiteHeader);
  const {
    details: { pageTitle, showSchedule, scheduleClosedMessage },
  } = useRootSelector(selectSiteContent);
  const schedule = useRootSelector(selectFestivalProSchedule);
  const scheduleStatus = useRootSelector(selectFestivalProScheduleStatus);

  useEffect(() => {
    if (showSchedule) {
      dispatch(fetchFestivalProEventSchedule({ eventId }));
    }
  }, [dispatch, eventId, showSchedule]);

  const loading = scheduleStatus === 'pending';
  const showError = scheduleStatus === 'rejected';
  const showContent = scheduleStatus === 'fulfilled';

  return (
    <SiteLayout>
      {loading && <Spinner />}
      {showError && <ExternalError />}
      {showContent && (
        <div className={s.wrapper}>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                {pageTitle && <h1 className={s.heading}>{pageTitle}</h1>}
                {schedule.tabs?.length > 0 && (
                  <Schedule schedule={schedule} showSidebar />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {!showSchedule && <ClosedSchedule message={scheduleClosedMessage} />}
    </SiteLayout>
  );
}
